<template>
    <div class="col-12 col-md-6">
        <div class="activities__search mb-2">
            <input
                v-model="searchTerm"
                class="search__input"
                type="text"
                placeholder="Zoek op trefwoorden"
            />
            <button>
                <i class="fa fa-search" aria-hidden="true"></i>
            </button>
        </div>
        <div class="activities__search">
            <input
                v-model="searchTermLocation"
                class="search__input"
                type="text"
                placeholder="Zoek op plaats"
            />
            <button><i class="fa fa-search" aria-hidden="true"></i></button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        searchTerm: {
            type: String,
            default: ''
        },
        searchTermLocation: {
            type: String,
            default: ''
        }
    },
    watch: {
        searchTerm: function() {
            this.$emit('search', this.searchTerm);
        },
        searchTermLocation: function() {
            this.$emit('searchLocation', this.searchTermLocation);
        }
    }
};
</script>

<style lang="scss" scoped>
.activities__search {
    border-radius: 28px;
    border: 0;
    font-size: 1.125rem;
    color: $gray-4;
    padding: 0 20px;
    position: relative;
    width: 100%;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.05);
    background-color: $white;
}

.activities__search button {
    border: 0;
    background: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
}

.activities__search input {
    display: inline-block;
    border: 0;
    width: calc(100% - 50px);
    line-height: 24px;

    &::placeholder {
        color: $gray-4;
    }

    &:focus {
        outline: none;
    }
}

.activities__search i {
    color: $blue-7;
    font-size: 1.25rem;
}
</style>
